<template>
    <row>
        <col2>
            <filter-tree
                    :initial_filter="[
                {'type':27, 'value':''},
                {'type':23, 'value':'No'},
                {'type':9, 'value':'No'},
                {'type':11, 'value':'No'},
                {'type':61, 'value':'No'},
                {'type':7, 'value':''}
               ]"
                    @update="update"
                    @load="load" :max_results="max_results"></filter-tree>
        </col2>
        <col10>
            <asset-grid @update_selection_asset_ids="update_selection_asset_ids" @reload="load" :items="items"></asset-grid>
        </col10>
    </row>
</template>

<script>
  import FilterTree from "@/components/asset_filter/FilterTree";
  import AssetGrid from "@/components/AssetGrid";
  import Row from "@/components/layout/Row";
  import Col2 from "@/components/layout/Col2";
  import Col10 from "@/components/layout/Col10";
  export default {
    name: "FilterAssetWithPreview",
    components: {AssetGrid, FilterTree, Row, Col2, Col10},
    data () {
      return {
        'items': [],
        'max_results': 12,
        'base_colors': [
        [249, 65, 68],
        [243, 114, 44],
        [248, 150, 30],
        [67, 170, 139],
        [249, 132, 74],
        [249, 199, 79],
        [144, 190, 109],
        [77, 144, 142],
        [87, 117, 144],
        [39, 125, 161],
        [249, 65, 68],
        [243, 114, 44],
        [248, 150, 30],
        [67, 170, 139],
      ]
      }
    },
    methods: {
      update_selection_asset_ids(asset_ids) {
        this.$emit('update_selection_asset_ids', asset_ids)
      },
      update (filters) {
        this.$emit('update_filter', filters)
      },
      applyAnnotationsWithLabels(items, labelsById) {
        items.forEach((item) => {
          try {
            item.annotations = item.relationships.annotations.map((annotation) => {
              let label = labelsById[annotation.label_id];
              if (!label) {
                let random_color = this.base_colors[Math.floor(Math.random() * this.base_colors.length)];
                annotation.coords = JSON.parse(annotation.coords);
                annotation.color_values = random_color;
                annotation.type = annotation.type === 1 ? 'box' : 'point';
                annotation.label = '?';
                annotation.conf = annotation.certainty === null ? 1 : annotation.certainty;
                annotation.show = true;
                annotation.selected = false;
                annotation.skip_zoom = true;
                return annotation;
              }
              annotation.coords = JSON.parse(annotation.coords);
              if (label.color) {
                annotation.color_values = label.color.split(',');
              } else {
                let random_color = this.base_colors[Math.floor(Math.random() * this.base_colors.length)];
                annotation.color_values = random_color;
              }
              annotation.type = annotation.type === 1 ? 'box' : 'point';
              annotation.label = label.name;
              annotation.conf = annotation.certainty === null ? 1 : annotation.certainty;
              annotation.show = true;
              annotation.selected = false;
              annotation.skip_zoom = true;
              return annotation;
            });
          } catch (error) {
            console.log(error);
            item.annotations = [];
          }
          item.checked = true;
          item.path = this.$api_host + '/' + item.static_path;
        });
      },
      async load(filters, limit) {
        this.$emit('update_filter', filters)

        if(!filters) {
          filters = this.filters
          limit = this.limit
        }

        const filterResult = await this.$api.asset.filter(filters, limit, { include_count: true });
        let items = filterResult;
        let bundledCount = null;
        if (filterResult && typeof filterResult === 'object' && Array.isArray(filterResult.items)) {
          items = filterResult.items;
          bundledCount = filterResult.count;
        }
        if (!Array.isArray(items)) {
          items = [];
        }
        if (bundledCount != null) {
          this.max_results = bundledCount;
        } else {
          let this2 = this;
          this.$api.asset.count_filter(filters).then((count) => {
            this2.max_results = count;
          });
        }
        this.$emit('loaded')

        if (items.length === 0) {
          this.loading = false;
          this.max_results = 0;
        }

        const idSet = new Set();
        items.forEach((item) => {
          ((item.relationships && item.relationships.annotations) || []).forEach((a) => {
            if (a.label_id) {
              idSet.add(a.label_id);
            }
          });
        });
        const labelIds = Array.from(idSet);
        let labelsById = {};
        if (labelIds.length > 0) {
          const labels = (await this.$api.label.fetchByIds(labelIds)) || [];
          labels.forEach((l) => {
            labelsById[l.id] = l;
          });
        }
        this.applyAnnotationsWithLabels(items, labelsById);
        this.items = items;
      }
    }
  }
</script>

<style scoped>

</style>